/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-07-09 17:34:24 
 * @Last Modified by:   syyoon@yongtrim.com 
 * @Last Modified time: 2018-07-09 17:34:24 
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { ENV } from '../env/env';
import { TransService } from './trans.service';

@Injectable()
export class VerifyService {

  constructor(
    private transService: TransService,
    private http: HttpClient) {
  }

  sendPhoneToken(phone) {
    return this.http.get(`${ENV.SERVER_URL}/${ENV.API_PATH}/verify/phone?phone=${phone}&lang=${this.transService.lang}`);
  }

  verifyPhoneToken(phone, token) {
    return this.http.post(`${ENV.SERVER_URL}/${ENV.API_PATH}/verify/phone/${phone}?lang=${this.transService.lang}`, {
      token: token
    });
  }

  verifyAddress(address) {
    return this.http.get(`${ENV.SERVER_URL}/${ENV.API_PATH}/address?q=${address}&lang=${this.transService.lang}`);
  }

}


// WEBPACK FOOTER //
// ./src/services/verify.service.ts